import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent } from 'react';
import styles from './StepButton.module.scss';

interface StepButtonProps {
    label: string;
    disabled?: boolean;
    loading?: boolean;
    onClick?: () => void;
    className?: string;
}

export const StepButton: FunctionComponent<StepButtonProps> = props => {
    return (
        <div className={styles.container}>
            <Button
                label={props.label}
                variant="primary"
                size="large"
                disabled={props.disabled}
                isLoading={props.loading}
                onClick={props.onClick}
                className={props.className}
            />
        </div>
    );
};

export default StepButton;
